/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A localized amount of money (no recursive localization)
 * @export
 * @interface LocalizedCurrencyAmount
 */
export interface LocalizedCurrencyAmount {
    /**
     * 
     * @type {number}
     * @memberof LocalizedCurrencyAmount
     */
    value: number;
    /**
     * 
     * @type {string}
     * @memberof LocalizedCurrencyAmount
     */
    currency: string;
}

/**
 * Check if a given object implements the LocalizedCurrencyAmount interface.
 */
export function instanceOfLocalizedCurrencyAmount(value: object): value is LocalizedCurrencyAmount {
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    return true;
}

export function LocalizedCurrencyAmountFromJSON(json: any): LocalizedCurrencyAmount {
    return LocalizedCurrencyAmountFromJSONTyped(json, false);
}

export function LocalizedCurrencyAmountFromJSONTyped(json: any, ignoreDiscriminator: boolean): LocalizedCurrencyAmount {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
        'currency': json['currency'],
    };
}

export function LocalizedCurrencyAmountToJSON(json: any): LocalizedCurrencyAmount {
    return LocalizedCurrencyAmountToJSONTyped(json, false);
}

export function LocalizedCurrencyAmountToJSONTyped(value?: LocalizedCurrencyAmount | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
        'currency': value['currency'],
    };
}

